const cartPopupApp = Vue.createApp({
    components: {
        'crosssells': CrossSells
    },
    data() {
        return {
            showOptions: false,
            discount: (window.partnerDiscount && window.customerIsPartner) ? window.partnerDiscount : window.discount
        }
    },
    template: `<transition name="modal">
    <div class="modal-mask" v-if="showModal">
      <div class="modal-wrapper" @click="close()">
        <div class="modal-container cart-popup-container" :class="{'loading': loading && !placeholder}" @click.stop="">
          <div class="modal-header">
            <i class="fa fa-check-circle" aria-hidden="true"></i> <span>Added to Cart</span>
          </div>
          <div class="modal-body">
            <div class="cart-table-container">
              <div class="row cart-table-row">
                <div class="col-sm-3 col-5">
                  <span class="product-image" :class="{'mirror': !croppedImage && cartItem && cartItem.properties && cartItem.properties['_flip'] && cartItem.properties['_flip'] !== false,'desaturate': cartItem && cartItem.properties && cartItem.properties['_bw'] && cartItem.properties['_bw'] !== false }"><img :src="image" alt=""></span>
                </div>
                <div class="col-sm-9 col-7 product-details-wrapper">
                  <div class="row">
                    <div class="col-sm-7">
                      <div class="product-details">
                        <span class="product-type" v-if="productType">{{productType}}</span>
                        <span class="product-name" v-html="item.title"></span>
                        <div class="item-options" v-if="item.type !== 'FixedPrice'">
                          <p class="item-option size-options">
                            <template v-if="item.type === 'wallpaper'">
                              <span><strong>Roll Size:</strong>&nbsp;{{rollSize}}&nbsp;&nbsp;&nbsp;</span>
                              <span><strong>Quantity:</strong>&nbsp;{{quantity}}</span>
                            </template>
                            <template v-else>
                              <span><strong>Width:</strong>&nbsp;{{width}}&nbsp;&nbsp;&nbsp;</span>
                              <span><strong>Height:</strong>&nbsp;{{height}}</span>                            
                            </template>
                          </p>
                          <div class="more-options-container" :class="{'show-options':showOptions}">
                            <template v-if="item.type === 'canvas' && comments">
                              <p class="item-option more-options-trigger"><a href="#" class="more-options-link" @click.prevent="showOptions = !showOptions">See comments</a></p>
                              <p class="item-option" v-html="comments"></p>
                            </template>
                            <template v-if="item.type !== 'canvas'">
                              <p class="item-option more-options-trigger"><a href="#" class="more-options-link" @click.prevent="showOptions = !showOptions">See options &amp; comments</a></p>
                              <p class="item-option" v-if="materials"><strong>Materials:</strong>&nbsp;{{materials}}</p>
                              <p class="item-option" v-if="options"><strong>Options:</strong>&nbsp;{{options}}</p>
                              <p class="item-option" v-if="topcoat"><strong>Topcoat:</strong>&nbsp;{{topcoat}}</p>
                              <p class="item-option" v-if="comments"><strong>Comments:</strong>&nbsp;{{comments}}</p>
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-5 product-price-container">
                      <div class="product-price">
                        <template v-if="discount && responseItem['product_type'] !== 'FixedPrice'">
                          <p class="old-price">
                            <span v-if="placeholder" class="price"><span class="text-placeholder">&nbsp;</span></span>
                            <span v-else class="price">{{formatCurrency(responseItem.original_line_price)}}</span>
                          </p>
                          <p class="special-price" v-if="!placeholder">
                            <span class="price">{{formatCurrency(specialPrice)}}</span>
                          </p>
                          <span v-if="!placeholder" class="price-disclaimer">with your {{discount}}% discount</span>                        
                        </template>
                        <template v-else>
                          <p class="special-price">
                            <span v-if="placeholder" class="price"><span class="text-placeholder">&nbsp;</span></span>
                            <span v-else class="price">{{formatCurrency(responseItem.line_price)}}</span>
                          </p>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div v-if="placeholder" class="minicart-subtotal"><span class="text-placeholder">&nbsp;</span></div>
            <div v-else class="minicart-subtotal" v-html="total"></div>       
            <div class="minicart-actions">
              <div class="row">
                <div class="col-6 col-sm-3"><a href="/cart" class="btn" :class="{'disabled-btn':placeholder}">View Cart</a></div>
                <div class="col-6 col-sm-3"><a href="#" class="btn popup-close" @click.prevent="close()" :class="{'disabled-btn':placeholder}">Continue Shopping</a></div>
                <div class="col-12 col-sm-5 offset-sm-1"><a href="/checkout" class="btn primary" :class="{'disabled-btn':placeholder}">Checkout</a></div>
              </div>
            </div>  
            <!-- <crosssells v-if="!placeholder" :item="item"></crosssells> -->
            <div 
                class="cart-benefits cart-benefits--mini" 
                v-if="benefits.length"
            >
                <div class="benefit-items">
                    <div 
                        class="benefit-item" 
                        v-for="(item, index) in benefits" 
                        :key="index"
                    >
                        <div class="benefit-inner">
                            <div class="benefit-image">
                                <img :src="item.icon" />
                            </div>
                            <div class="benefit-text">
                                <strong>{{ item.title }}</strong>
                                <p>{{ item.description }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </div>
          <button class="modal-close button button--close" @click="close()"><span class="sr-only">Close</span><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17"><path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"/></svg></button>
        </div>
      </div>
    </div>
    </transition>`,
    computed: {
        showModal() {
            return store.getters['cartPopup/show'];
        },
        total() {
            return store.getters['cartPopup/total'] ? new DOMParser()
                .parseFromString(store.getters['cartPopup/total'], 'text/html')
                .querySelector('.shopify-section').innerHTML : null;
        },
        item() {
            return store.getters['cartPopup/item'];
        },
        loading() {
            return store.getters['cartPopup/loading'];
        },
        cartItem() {
            return this.requestItem && this.requestItem.hasOwnProperty('items') ? this.requestItem.items[0] : {};
        },
        size() {
            let s = {
                'width': null,
                'height': null,
            };
            if(this.cartItem && this.cartItem.hasOwnProperty('properties')) {
                if(this.cartItem.properties.hasOwnProperty('Size')) {
                    let sa = this.cartItem.properties['Size'].split('x');
                    s['width'] = sa[0].trim();
                    s['height'] = sa[1].trim();
                } else {
                    if(this.cartItem.properties.hasOwnProperty('Width')) {
                        s['width'] = this.cartItem.properties['Width'];
                    }
                    if(this.cartItem.properties.hasOwnProperty('Height')) {
                        s['height'] = this.cartItem.properties['Height'];
                    }
                }
            }
            return s;
        },
        topcoat() {
            return this.cartItem && this.cartItem.hasOwnProperty('properties') && this.cartItem.properties.hasOwnProperty('Topcoat') ? this.cartItem.properties['Topcoat'] : null;
        },
        options() {
            return this.cartItem && this.cartItem.hasOwnProperty('properties') && this.cartItem.properties.hasOwnProperty('Options') ? this.cartItem.properties['Options'] : null;
        },
        materials() {
            return this.cartItem && this.cartItem.hasOwnProperty('properties') && this.cartItem.properties.hasOwnProperty('Materials') ? this.cartItem.properties['Materials'] : null;
        },
        comments() {
            return this.cartItem && this.cartItem.hasOwnProperty('properties') && this.cartItem.properties.hasOwnProperty('Comments') ? this.cartItem.properties['Comments'] : null;
        },
        width() {
            return this.size['width'];
        },
        height() {
            return this.size['height'];
        },
        rollSize() {
            return this.cartItem && this.cartItem.hasOwnProperty('properties') && this.cartItem.properties.hasOwnProperty('Size') ? this.cartItem.properties['Size'] : '';
        },
        quantity() {
            return this.cartItem && this.cartItem.hasOwnProperty('properties') && this.cartItem.properties.hasOwnProperty('Quantity') ? this.cartItem.properties['Quantity'] : '';
        },
        croppedImage() {
            return this.responseItem && this.responseItem.hasOwnProperty('properties') &&
                this.responseItem.properties.hasOwnProperty('_cropped_image') &&
                this.responseItem.properties['_cropped_image'] !== '' ? this.responseItem.properties['_cropped_image'] : null;
        },
        productType() {
            let t = null;
            if(this.item.type === 'mural') {
                t = 'Wall Mural';
            } else if(this.item.type === 'canvas') {
                t = 'Canvas';
            } else if(this.item.type === 'wallpaper') {
                t = 'Wallpaper';
            }
            return t;
        },
        image() {
            let src = this.item.url;
            if(this.item.type === 'FixedPrice' || this.item.type === 'ShopifyWallpaper' || this.item.type === 'ShopifyMural' || this.item.type === 'ShopifyCanvas') {
                src = this.item.featured_image;
            }
            if(this.croppedImage) {
                src = this.croppedImage;
            }
            return (this.item.type === 'canvas') ? this.previewUrl + src : src;
        },
        requestItem() {
            return store.getters['cartPopup/requestItem'];
        },
        placeholder() {
            return store.getters['cartPopup/placeholder'];
        },
        responseItem() {
            return store.getters['cartPopup/responseItem'] || {};
        },
        specialPrice() {
            return this.responseItem.original_line_price * (1 - (Number(this.discount) / 100));
        },
        benefits() {
            return window.cartBenefits || [];
        },
    },
    methods: {
        close() {
            if(!this.placeholder) {
                if(this.item.custom === true) {
                    store.dispatch('cartPopup/loading', {loading: true});
                    window.location.reload();
                } else {
                    store.dispatch('cartPopup/close')
                }
            }
        },
        save() {
            console.log('save cart');
        }
    }
})
cartPopupApp.use(AdobeClientPlugin).use(store);
cartPopupApp.config.compilerOptions.isCustomElement = tag => tag.includes('-') && !tag.includes('router') && !tag.includes('api')
cartPopupApp.config.unwrapInjectedRef = true
cartPopupApp.mount('#cart-popup');
